import { useNavigate } from 'react-router-dom';

import { cn } from 'src/shared/components/ui';
import { ButtonV2, Typography } from 'src/shared/components/ui';

const NotFoundPage = ({
  title = 'Page not found',
  description = 'This page does not exist or has been moved.',
  className
}: {
  title?: string;
  description?: string;
  className?: string;
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center h-screen',
        className
      )}
    >
      <Typography variant="h1" weight="bold">
        {title}
      </Typography>
      <Typography variant="body-1" className="mt-2">
        {description}
      </Typography>
      <ButtonV2 onPress={() => navigate('/')} className="mt-6">
        {title === 'Page not found' ? 'Take me home' : 'Go back'}
      </ButtonV2>
    </div>
  );
};

export default NotFoundPage;
